import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useB2BAuthStore } from '../../stores/useB2BAuthStore'

/**
 * Auth-guard для всех приватных /b2b/* роутов.
 * Если токен отсутствует или истёк — редирект на /b2b/auth.
 */
export default function RequireB2BAuth({ children }) {
  const isAuthenticated = useB2BAuthStore((s) => s.isAuthenticated)
  const refresh = useB2BAuthStore((s) => s.refresh)
  const location = useLocation()

  useEffect(() => {
    refresh()
  }, [refresh])

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/b2b/auth"
        replace
        state={{ redirectTo: `${location.pathname}${location.search}${location.hash}` }}
      />
    )
  }

  return children
}
